var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserFriendlyControl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 136,
    viewBox: "0 0 144 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6904 51.9322C13.6904 51.9322 15.6904 23.6322 18.5904 23.0322C21.4904 22.4322 30.5904 31.9322 30.5904 31.9322L28.9904 18.7322L20.6904 9.1322L14.0904 14.1322L5.69043 33.8322L8.29044 54.3322L13.6904 51.9322Z",
    fill: "url(#paint0_linear_62_925)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8906 14.4321C16.8906 17.1321 16.8906 19.7321 19.9906 22.4321C22.9906 25.0321 29.4906 29.2321 29.4906 29.2321L27.5906 18.4321L16.8906 14.4321Z",
    fill: "#BE2F55"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6904 67.1321C40.5904 68.8321 39.8904 70.2321 38.8904 71.4321C37.3904 73.0321 35.1904 74.1321 32.7904 74.3321C31.7238 74.3988 30.4238 74.1988 28.8904 73.7321C24.3904 72.4321 18.0904 68.8321 10.9904 62.6321C1.39045 54.3321 0.69043 49.4321 0.69043 49.4321C0.69043 49.4321 40.8904 62.9321 40.6904 67.1321Z",
    fill: "url(#paint1_linear_62_925)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6907 67.1322C40.2907 68.8322 38.8907 70.2322 32.1907 70.2322C25.5907 70.2322 1.79067 55.4322 0.690668 49.4322C-0.109332 45.3322 3.39067 24.2322 7.29067 11.0322C8.99067 5.5322 10.7907 1.43219 12.2907 0.632194C16.5907 -1.76781 29.5907 9.93219 34.8907 15.6322C35.0907 15.8989 35.2907 16.1322 35.4907 16.3322C36.2907 17.2322 36.7907 17.8322 36.9907 18.2322C38.3907 20.8322 37.1907 29.2322 33.4907 33.6322C32.8907 34.3322 32.2907 34.6322 31.7907 34.6322C29.3907 34.4322 28.3907 26.3322 28.0907 24.1322C27.8907 22.5322 23.5907 19.7322 20.3907 17.9322C18.6907 16.8322 17.2907 16.1322 17.2907 16.1322C16.1907 16.0322 14.8907 19.6322 13.7907 24.5322C11.6907 33.0322 10.1907 45.1322 11.1907 47.4322C11.2907 47.7322 11.6907 48.1322 12.3907 48.6322C16.5907 51.9322 30.4907 59.0322 32.7907 58.7322C34.9907 58.5322 34.3907 55.2322 34.8907 52.6322C34.9573 51.9655 35.1574 51.3655 35.4907 50.8322C35.4907 50.8322 35.4907 50.7989 35.4907 50.7322C37.0907 48.3322 40.6907 56.3322 40.6907 56.3322C40.6907 56.3322 40.7907 58.4322 40.8907 60.8322C40.8907 63.3322 40.8907 66.2322 40.6907 67.1322Z",
    fill: "url(#paint2_linear_62_925)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8907 60.8321C39.6907 61.0321 38.5907 60.8321 37.5907 60.0321C35.5907 58.2321 35.3907 53.8321 35.4907 50.7321C37.0907 48.3321 40.6907 56.3321 40.6907 56.3321C40.6907 56.3321 40.7907 58.4321 40.8907 60.8321Z",
    fill: "#DE5155"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4908 33.6322C32.8908 34.3322 32.2908 34.6322 31.7908 34.6322C30.1908 32.1322 29.3907 28.3322 29.5907 24.9322C29.8907 19.2322 34.8908 15.6322 34.8908 15.6322C35.9908 16.8322 36.7908 17.8322 36.9908 18.2322C38.3908 20.8322 37.1908 29.2322 33.4908 33.6322Z",
    fill: "#DE5155"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.69075 47.7322C2.49075 45.2322 1.79077 41.9322 3.99077 28.3322C6.29077 14.8322 10.7908 3.83221 13.8908 1.63221C15.3908 0.632211 20.7907 1.93221 18.0907 8.13221C9.89075 27.2322 6.59075 48.4322 5.69075 47.7322Z",
    fill: "#FF450C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8906 71.4323C37.3906 73.0323 35.1906 74.1323 32.7906 74.3323C31.724 74.399 30.424 74.1989 28.8906 73.7323C29.8906 72.6323 31.7906 71.0323 34.2906 70.7323C36.0906 70.5323 37.6906 70.9323 38.8906 71.4323Z",
    fill: "#A83D40"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4905 16.3322C30.5905 12.1322 18.7905 0.532197 14.9905 0.932197C10.1905 1.3322 7.29053 11.0322 7.29053 11.0322C8.99053 5.5322 10.7905 1.43219 12.2905 0.632194C16.5905 -1.76781 29.5905 9.93219 34.8905 15.6322C35.0905 15.8989 35.2905 16.1322 35.4905 16.3322Z",
    fill: "url(#paint3_linear_62_925)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7906 59.4323C23.8906 57.0323 15.4906 51.6323 12.3906 48.6323C16.5906 51.9323 30.4906 59.0323 32.7906 58.7323C34.9906 58.5323 34.3906 55.2323 34.8906 52.6323C35.1906 56.5323 34.7906 60.0323 32.7906 59.4323Z",
    fill: "url(#paint4_linear_62_925)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3909 17.9323C18.6909 16.8323 17.2909 16.1322 17.2909 16.1322C16.1909 16.0322 14.8909 19.6323 13.7909 24.5323H13.6908C13.3908 23.0323 15.0909 14.3323 16.8909 14.4323C18.5909 14.5323 20.3909 17.9323 20.3909 17.9323Z",
    fill: "#FF450C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0906 57.5323C8.89058 58.7323 27.6906 69.6323 33.0906 68.7323C38.4906 67.9323 39.5906 62.7323 37.5906 62.4323C35.5906 62.1323 33.0906 65.3323 25.9906 63.2323C18.7906 61.0323 10.9906 56.6323 10.0906 57.5323Z",
    fill: "#FF4D74"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5907 11.9322C7.6907 11.3322 10.2907 4.03223 11.5907 4.53223C14.1907 5.43223 9.8907 12.8322 8.5907 11.9322Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3905 55.1321C20.1905 54.9321 25.7905 59.3321 26.5905 57.7321C27.2905 56.4321 21.3905 55.1321 21.3905 55.1321Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M130.791 51.9322C130.791 51.9322 128.691 23.6322 125.791 23.0322C122.891 22.4322 113.891 31.9322 113.891 31.9322L115.391 18.7322L123.691 9.1322L130.391 14.1322L138.791 33.8322L136.191 54.3322L130.791 51.9322Z",
    fill: "url(#paint5_linear_62_925)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M127.591 14.4321C127.491 17.1321 127.491 19.7321 124.491 22.4321C121.391 25.0321 114.891 29.2321 114.891 29.2321L116.891 18.4321L127.591 14.4321Z",
    fill: "#BE2F55"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M103.691 67.1321C103.791 68.8321 104.491 70.2321 105.491 71.4321C106.991 73.0321 109.291 74.1321 111.591 74.3321C112.657 74.3988 113.991 74.1988 115.591 73.7321C119.991 72.4321 126.291 68.8321 133.391 62.6321C142.991 54.3321 143.791 49.4321 143.791 49.4321C143.791 49.4321 103.491 62.9321 103.691 67.1321Z",
    fill: "url(#paint6_linear_62_925)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M103.691 67.1322C104.191 68.8322 105.591 70.2322 112.191 70.2322C118.791 70.2322 142.591 55.4322 143.791 49.4322C144.591 45.3322 141.091 24.2322 137.091 11.0322C135.391 5.5322 133.691 1.43219 132.091 0.632194C127.791 -1.76781 114.791 9.93219 109.491 15.6322C109.291 15.8989 109.091 16.1322 108.891 16.3322C108.091 17.2322 107.591 17.8322 107.391 18.2322C105.991 20.8322 107.291 29.2322 110.891 33.6322C111.591 34.3322 112.091 34.6322 112.591 34.6322C114.991 34.4322 116.091 26.3322 116.291 24.1322C116.491 22.5322 120.791 19.7322 123.991 17.9322C125.791 16.8322 127.191 16.1322 127.191 16.1322C128.291 16.0322 129.491 19.6322 130.691 24.5322C132.691 33.0322 134.191 45.1322 133.291 47.4322C133.191 47.7322 132.691 48.1322 132.091 48.6322C127.791 51.9322 113.991 59.0322 111.591 58.7322C109.491 58.5322 110.091 55.2322 109.591 52.6322C109.457 51.9655 109.257 51.3655 108.991 50.8322C108.924 50.8322 108.891 50.7989 108.891 50.7322C107.291 48.3322 103.691 56.3322 103.691 56.3322C103.691 56.3322 103.591 58.4322 103.591 60.8322C103.491 63.3322 103.491 66.2322 103.691 67.1322Z",
    fill: "url(#paint7_linear_62_925)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M103.591 60.8321C104.691 61.0321 105.791 60.8321 106.891 60.0321C108.891 58.2321 109.091 53.8321 108.891 50.7321C107.291 48.3321 103.691 56.3321 103.691 56.3321C103.691 56.3321 103.591 58.4321 103.591 60.8321Z",
    fill: "#DE5155"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M110.89 33.6322C111.59 34.3322 112.09 34.6322 112.59 34.6322C114.19 32.1322 114.99 28.3322 114.89 24.9322C114.59 19.2322 109.49 15.6322 109.49 15.6322C108.39 16.8322 107.69 17.8322 107.39 18.2322C105.99 20.8322 107.29 29.2322 110.89 33.6322Z",
    fill: "#DE5155"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M138.79 47.7322C141.89 45.2322 142.59 41.9322 140.39 28.3322C138.19 14.8322 133.59 3.83221 130.49 1.63221C128.99 0.632211 123.59 1.93221 126.29 8.13221C134.49 27.2322 137.79 48.4322 138.79 47.7322Z",
    fill: "#FF450C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M105.491 71.4323C106.991 73.0323 109.291 74.1323 111.591 74.3323C112.657 74.399 113.991 74.1989 115.591 73.7323C114.591 72.6323 112.691 71.0323 110.191 70.7323C108.291 70.5323 106.691 70.9323 105.491 71.4323Z",
    fill: "#A83D40"
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M108.891 16.3322C113.891 12.1322 125.591 0.532197 129.491 0.932197C134.191 1.3322 137.091 11.0322 137.091 11.0322C135.391 5.5322 133.691 1.43219 132.091 0.632194C127.791 -1.76781 114.791 9.93219 109.491 15.6322C109.291 15.8989 109.091 16.1322 108.891 16.3322Z",
    fill: "url(#paint8_linear_62_925)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M111.591 59.4323C120.591 57.0323 128.891 51.6323 132.091 48.6323C127.791 51.9323 113.991 59.0323 111.591 58.7323C109.491 58.5323 110.091 55.2323 109.591 52.6323C109.291 56.5323 109.591 60.0323 111.591 59.4323Z",
    fill: "url(#paint9_linear_62_925)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M123.991 17.9323C125.791 16.8323 127.191 16.1322 127.191 16.1322C128.291 16.0322 129.491 19.6323 130.691 24.5323C131.091 23.0323 129.291 14.3323 127.591 14.4323C125.791 14.5323 123.991 17.9323 123.991 17.9323Z",
    fill: "#FF450C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M134.291 57.5323C135.591 58.7323 116.691 69.6323 111.291 68.7323C105.891 67.9323 104.791 62.7323 106.891 62.4323C108.891 62.1323 111.291 65.3323 118.491 63.2323C125.591 61.0323 133.391 56.6323 134.291 57.5323Z",
    fill: "#FF4D74"
  }))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M135.791 11.9322C136.691 11.3322 134.191 4.03223 132.791 4.53223C130.191 5.43223 134.491 12.8322 135.791 11.9322Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M123.091 55.1321C124.191 54.9321 118.691 59.3321 117.791 57.7321C117.091 56.4321 123.091 55.1321 123.091 55.1321Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1907 74.4322C86.0907 76.0322 84.3907 77.3322 83.6907 77.9322C83.8907 78.8322 83.7907 80.8322 83.6907 82.4322C83.5907 83.3322 83.4907 84.1322 83.4907 84.4322C83.4907 84.5655 83.4574 84.6989 83.3907 84.8322C83.1907 85.3322 82.6907 85.6322 82.2907 85.7322C82.0907 85.9322 81.8907 85.9322 81.8907 85.9322V101.932C98.6907 107.632 101.691 127.232 101.691 127.232C101.691 132.032 87.5907 135.132 71.4907 135.132C55.8907 135.132 43.3907 132.432 42.6907 127.632C42.6907 127.499 42.6907 127.366 42.6907 127.232C42.6907 127.232 45.5907 107.632 62.4907 101.932V85.9322C62.4907 85.9322 60.9907 85.5322 60.8907 84.4322C60.8907 84.1322 60.7907 83.3322 60.6907 82.4322C60.4907 80.8322 60.3907 78.8322 60.6907 77.9322C60.1907 77.5322 59.2907 76.8322 58.0907 76.0322C53.7907 72.6322 45.6907 66.1322 41.0907 60.6322C36.1907 54.7322 32.9907 40.6322 33.5907 28.0322C33.6907 24.0322 34.2907 20.3322 35.1907 16.9322C35.5907 15.5322 36.1907 14.2322 36.9907 13.0322C36.9907 13.0322 36.9907 12.9989 36.9907 12.9322C36.9907 12.9322 37.1907 12.5322 37.5907 12.0322L37.9907 11.5322C38.124 11.3322 38.2574 11.1655 38.3907 11.0322C46.1907 2.23221 63.6907 0.632202 72.1907 0.632202C81.7907 0.632202 102.891 2.6322 108.391 14.8322C108.724 15.4989 108.991 16.1989 109.191 16.9322C110.091 20.4322 110.691 24.4322 110.791 28.4322C110.791 28.4322 110.791 28.4655 110.791 28.5322C111.291 41.0322 108.091 54.8322 103.191 60.6322C99.2907 65.3322 92.7907 70.8322 88.1907 74.4322Z",
    fill: "url(#paint10_linear_62_925)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M101.69 127.232C101.69 132.032 87.5904 135.132 71.4904 135.132C55.8904 135.132 43.3904 132.432 42.6904 127.632C42.6904 127.632 53.8904 122.232 72.1904 122.632C90.5904 122.932 101.69 127.232 101.69 127.232Z",
    fill: "url(#paint11_linear_62_925)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1906 74.4321C86.0906 76.0321 84.3906 77.3321 83.6906 77.9321C70.6906 72.7321 60.6906 77.9321 60.6906 77.9321C60.1906 77.5321 59.2906 76.8321 58.0906 76.0321C57.7906 72.3321 66.4906 64.7321 73.2906 63.1321C78.4906 61.8321 85.9906 69.4321 88.1906 74.4321Z",
    fill: "#DE5155"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M103.191 60.6322C99.2907 65.3322 92.7907 70.8322 88.1907 74.4322C86.0907 76.0322 84.3907 77.3322 83.6907 77.9322C78.3907 76.2322 73.6907 72.9322 60.6907 77.9322C60.1907 77.5322 59.2907 76.8322 58.0907 76.0322C53.7907 72.6322 45.6907 66.1322 41.0907 60.6322C36.1907 54.7322 32.9907 40.6322 33.5907 28.0322C33.5907 29.3322 34.4907 47.9322 43.5907 57.4322C53.0907 67.2322 67.2907 71.1322 73.1907 72.5322C78.9907 73.9322 94.7907 65.1322 101.891 56.3322C108.191 48.4322 110.491 31.5322 110.791 28.5322C111.291 41.0322 108.091 54.8322 103.191 60.6322Z",
    fill: "#DE5155"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M83.3906 84.8321C82.9906 85.6321 81.8906 85.9321 81.8906 85.9321C81.8906 85.9321 78.1906 84.0321 73.5906 84.0321C68.8906 84.0321 62.4906 85.9321 62.4906 85.9321C62.4906 85.9321 60.9906 85.5321 60.8906 84.4321C61.7906 84.0321 66.6906 81.5321 73.9906 82.0321C81.2906 82.5321 83.1906 84.3321 83.3906 84.8321Z",
    fill: "#DE5155"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M101.69 127.232C101.69 127.699 101.557 128.132 101.29 128.532C98.9904 132.632 86.0904 135.132 71.4904 135.132C62.3904 135.132 54.3904 134.232 49.0904 132.432C45.2904 131.232 42.9904 129.632 42.6904 127.632C42.6904 127.499 42.6904 127.366 42.6904 127.232C42.6904 127.232 45.5904 107.632 62.4904 101.932V85.9323C62.4904 85.9323 63.0904 84.8323 72.1904 84.1323C77.1904 83.7323 80.4904 84.7323 82.2904 85.7323C82.0904 85.9323 81.8904 85.9323 81.8904 85.9323V101.932C98.6904 107.632 101.69 127.232 101.69 127.232Z",
    fill: "#DE5155"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1905 98.0322C76.0905 97.3322 79.2905 99.7321 79.9905 99.2321C80.7905 98.7321 80.5905 89.3322 80.1905 87.6322C79.3905 84.4322 74.3905 88.8322 71.1905 88.0322C68.3905 87.2322 70.7905 98.2322 72.1905 98.0322Z",
    fill: "#DE5155"
  }))), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M98.2905 124.732C98.2905 124.732 83.6905 96.6322 62.4905 104.132C47.2905 109.532 41.2905 125.132 47.1905 123.632C65.7905 118.932 92.1905 121.032 98.2905 124.732Z",
    fill: "url(#paint12_linear_62_925)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8906 62.1322C47.5906 61.3322 31.9906 30.1322 38.5906 18.7322C45.0906 7.33221 74.6906 3.63222 83.3906 6.53222C92.0906 9.33222 64.8906 62.6322 57.8906 62.1322Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0905 82.8322C60.6905 83.0322 60.9906 79.1322 62.2906 78.4322C63.6906 77.6322 70.9905 75.1322 80.6905 77.4322C84.1905 78.2322 67.6905 82.0322 62.0905 82.8322Z",
    fill: "white"
  }))), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7905 83.5322C61.1905 83.1322 60.4905 77.7322 61.9905 77.6322C63.5905 77.5322 66.2905 76.1322 66.6905 76.6322C67.0905 77.1322 67.6905 81.1322 66.6905 81.8322C65.6905 82.6322 61.9905 83.7322 61.7905 83.5322Z",
    fill: "#FFCD00"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M108.391 14.9322C108.391 14.9322 97.0907 2.73221 73.6907 1.93221C50.7907 1.23221 37.5907 12.5322 36.9907 12.9322C36.9907 12.9322 37.1907 12.5322 37.5907 12.0322L37.9907 11.5322C38.1241 11.3322 38.2574 11.1655 38.3907 11.0322C46.1907 2.23221 63.6907 0.632202 72.1907 0.632202C81.7907 0.632202 102.891 2.6322 108.391 14.8322C108.391 14.8989 108.391 14.9322 108.391 14.9322Z",
    fill: "url(#paint13_linear_62_925)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M104.491 14.9322C99.0909 10.1322 95.4909 51.9321 100.991 47.7321C106.491 43.4321 107.091 17.2322 104.491 14.9322Z",
    fill: "#DE5155"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6904 77.9323C60.6904 77.9323 67.0904 73.9322 73.1904 74.7322C79.2904 75.5322 83.6904 77.9323 83.6904 77.9323C83.6904 77.9323 76.9904 75.4323 73.1904 75.3323C69.3904 75.1323 60.6904 77.9323 60.6904 77.9323Z",
    fill: "#DE5155"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M81.7907 101.932C81.3907 101.632 77.7907 99.6322 72.5907 99.7322C67.0907 99.7322 62.4907 101.932 62.4907 101.932V101.632C64.1907 100.932 68.6907 99.2322 72.4907 99.2322C77.9907 99.2322 81.3907 101.632 81.7907 101.932Z",
    fill: "#DE5155"
  }))), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4908 22.8321C41.1908 25.2321 38.3908 18.7321 40.6908 17.7321C42.9908 16.7321 46.5908 19.8321 43.4908 22.8321Z",
    fill: "white"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0908 6.13217C52.2908 5.13217 54.3908 3.23217 62.7908 1.93217C71.1908 0.632175 74.0908 0.832178 72.6908 2.73218C71.2908 4.53218 51.7908 7.63217 52.0908 6.13217Z",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0907 82.8323C60.6907 82.2323 64.5907 80.4323 65.4907 81.2323C66.4907 82.1323 61.4907 83.3323 61.0907 82.8323Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0908 120.332C47.9908 115.432 57.4908 104.232 65.5908 104.332C73.6908 104.432 71.0908 115.032 64.0908 118.932C60.0908 121.232 46.3908 123.732 47.0908 120.332Z",
    fill: "white"
  }))), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0904 132.132C47.4904 131.932 42.6904 131.232 42.6904 127.632C42.6904 124.832 57.1904 123.032 59.5904 123.332C59.5904 123.332 43.2904 125.732 43.2904 128.132C43.2904 130.732 48.0904 132.132 48.0904 132.132Z",
    fill: "url(#paint14_linear_62_925)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3905 107.432C56.8905 105.832 54.0905 109.532 55.5905 110.332C56.9905 111.232 60.8905 108.332 59.3905 107.432Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6905 100.032C64.7905 100.132 68.3905 100.032 68.6905 98.4323C69.0905 96.8323 68.4905 85.3323 66.8905 85.6323C65.2905 85.8323 63.6905 85.0323 63.2905 86.4323C62.9905 87.9323 62.9905 100.032 63.6905 100.032Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6909 82.9323C83.4909 82.8323 83.6909 78.3323 82.6909 78.4323C81.7909 78.5323 76.7909 79.9323 77.2909 80.6323C77.7909 81.4323 81.7909 83.0323 82.6909 82.9323Z",
    fill: "#DE5155"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M101.291 128.532C98.9909 132.632 86.0909 135.132 71.4909 135.132C62.3909 135.132 54.3909 134.232 49.0909 132.432C48.0909 131.032 47.6909 129.532 49.3909 128.432C52.6909 126.232 78.0909 122.432 93.9909 126.132C96.9909 126.832 99.3909 127.632 101.291 128.532Z",
    fill: "#BE2F55"
  }))), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2908 129.832C47.3908 129.732 46.0908 128.732 46.9908 128.432C47.9908 128.132 49.4908 128.032 50.2908 128.232C51.0908 128.532 53.2908 130.532 48.2908 129.832Z",
    fill: "#A83000"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3909 128.332C48.3909 128.332 49.6909 128.432 49.4909 129.232C49.1909 130.032 46.1908 129.632 46.5908 128.732C46.7908 128.332 48.1909 128.232 48.3909 128.332Z",
    fill: "#BE2F55"
  }))), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6909 129.032C49.6909 128.932 49.0909 128.432 49.4909 128.332C49.8909 128.232 51.5909 128.732 51.4909 129.332C51.2909 129.832 48.7909 130.232 48.9909 129.832C49.2909 129.432 49.6909 129.632 49.6909 129.032Z",
    fill: "#FF9500"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5906 134.532C81.1906 134.532 80.3906 134.032 80.6906 133.532C80.9906 133.032 84.5906 131.832 86.1906 132.232C87.6906 132.532 87.0906 134.532 82.5906 134.532Z",
    fill: "#A83000"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5908 133.532C80.6908 133.032 83.2908 132.232 83.4908 133.232C83.6908 134.232 80.5908 134.932 80.5908 133.532Z",
    fill: "#BE2F55"
  }))), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M83.1909 132.432C83.6909 132.632 84.2909 133.132 84.1909 133.532C84.1909 133.932 82.9909 134.132 83.2909 134.332C83.5909 134.532 87.9909 134.032 86.7909 132.732C85.6909 131.532 82.7909 132.232 83.1909 132.432Z",
    fill: "#FF9500"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2905 83.8323C62.3905 83.7323 67.4905 81.2323 71.7905 81.4323C76.0905 81.6323 77.5905 82.6323 77.5905 82.6323C77.5905 82.6323 74.7905 81.6323 69.9905 82.0323C65.1905 82.5323 62.2905 83.8323 62.2905 83.8323Z",
    fill: "url(#paint15_linear_62_925)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1904 61.3323C13.1904 61.3323 27.4904 72.0323 33.8904 70.8323C40.2904 69.5323 40.1904 68.2323 40.1904 68.2323C40.1904 68.2323 38.2904 69.7323 31.4904 69.7323C24.6904 69.6323 13.1904 61.3323 13.1904 61.3323Z",
    fill: "url(#paint16_linear_62_925)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M104.791 68.8322C104.791 68.8322 107.591 71.7322 113.091 70.7322C118.491 69.6322 133.791 59.5322 133.791 59.5322C133.791 59.5322 116.691 70.3322 112.191 70.2322C107.691 70.1322 104.791 68.8322 104.791 68.8322Z",
    fill: "url(#paint17_linear_62_925)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_62_925",
    x1: -22.8126,
    y1: 54.2822,
    x2: -22.8126,
    y2: 9.1472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F66A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F63F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_62_925",
    x1: 12.9374,
    y1: 74.3491,
    x2: 12.9374,
    y2: 49.4791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E31300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D93800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_62_925",
    x1: 81.2577,
    y1: 0.298194,
    x2: 81.2577,
    y2: 70.2042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAA800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.849,
    stopColor: "#FF7F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F63F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_62_925",
    x1: 7.33753,
    y1: 0.298194,
    x2: 35.4965,
    y2: 0.298194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE834"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCD00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_62_925",
    x1: 12.3696,
    y1: 48.6283,
    x2: 34.9536,
    y2: 48.6283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE834"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCD00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_62_925",
    x1: 167.224,
    y1: 54.2822,
    x2: 167.224,
    y2: 9.1472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F66A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F63F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_62_925",
    x1: 131.474,
    y1: 74.3491,
    x2: 131.474,
    y2: 49.4791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E31300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D93800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_62_925",
    x1: 63.1536,
    y1: 0.298194,
    x2: 63.1536,
    y2: 70.2042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAA800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.849,
    stopColor: "#FF7F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F63F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_62_925",
    x1: 137.074,
    y1: 0.298194,
    x2: 108.915,
    y2: 0.298194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE834"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCD00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_62_925",
    x1: 132.042,
    y1: 48.6283,
    x2: 109.458,
    y2: 48.6283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE834"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCD00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_62_925",
    x1: -44.7803,
    y1: 135.099,
    x2: -44.7803,
    y2: 0.596206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_62_925",
    x1: 73.5174,
    y1: 122.578,
    x2: 73.5174,
    y2: 135.099,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F63F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.553,
    stopColor: "#F66A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA9300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_62_925",
    x1: 98.2515,
    y1: 102.877,
    x2: 44.9465,
    y2: 102.877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_62_925",
    x1: 36.9837,
    y1: 0.595202,
    x2: 108.423,
    y2: 0.595202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE834"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_62_925",
    x1: 42.7014,
    y1: 123.288,
    x2: 59.6244,
    y2: 123.288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE834"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_62_925",
    x1: 62.2845,
    y1: 81.4153,
    x2: 77.6325,
    y2: 81.4153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE834"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_62_925",
    x1: 13.2164,
    y1: 61.3213,
    x2: 40.1834,
    y2: 61.3213,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE834"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_62_925",
    x1: 104.828,
    y1: 59.5202,
    x2: 133.825,
    y2: 59.5202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE834"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserFriendlyControl);
export default __webpack_public_path__ + "static/media/user_friendly_control.7ebc885ab1364c74f17025b64407b5db.svg";
export { ForwardRef as ReactComponent };